<template>
    <div height="medium" width="large">
        <div class="container">
            <h2 class="heading">{{ $t('modals.patient.tab.label_three') }}</h2>
            <form-wrapper @submit="handleFormSubmission()">
                <div class="Cards">
                    <div class="main-data main-card">
                        <div>
                            <common-icon name="user" size="medium"></common-icon>
                            <span class="card-title">
                                {{ $t('modals.patient_profile.profile.card_head') }}
                            </span>
                        </div>
                        <div class="edit-export">
                            <input
                                v-if="isExportProfileClicked"
                                v-model="selectedExportFields.profile"
                                type="checkbox"
                                class="export-checkbox"
                            />
                        </div>
                    </div>
                    <div>
                        <form-row>
                            <form-cell v-if="!isProfileEditable" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.full_name.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.full_name.placeholder')"
                                    :isDisabled="!isProfileEditable"
                                    :formData="{ fullName }"
                                    valuePath="fullName"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell v-if="isProfileEditable" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.first_name.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.first_name.placeholder')"
                                    :formData="data"
                                    valuePath="firstName"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell v-if="isProfileEditable" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.last_name.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.last_name.placeholder')"
                                    :formData="data"
                                    valuePath="lastName"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.dob.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.dob.placeholder')"
                                    :isDisabled="!isProfileEditable"
                                    :isRequired="false"
                                    :maxDate="maxSelectableDate"
                                    :formData="data"
                                    valuePath="dob"
                                    type="date"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell v-if="!isProfileEditable" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.gender.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.gender.placeholder')"
                                    :isDisabled="true"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="gender"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell v-if="isProfileEditable" width="half">
                                <radio-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.gender.label')"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="gender"
                                    :options="genderOptions"
                                    @change="change($event)"
                                ></radio-field>
                            </form-cell>
                        </form-row>
                        <form-row>
                            <form-cell v-if="!isProfileEditable" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.marital_status.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.marital_status.placeholder')"
                                    :isDisabled="true"
                                    :formData="data"
                                    valuePath="maritalStatus"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell v-if="isProfileEditable" width="half">
                                <select-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.marital_status.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.marital_status.placeholder')"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="maritalStatus"
                                    :options="maritalStatusOptions"
                                    @change="change($event)"
                                ></select-field>
                            </form-cell>
                            <form-cell v-if="!isProfileEditable" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.language.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.language.placeholder')"
                                    :isDisabled="true"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="preferredLanguage"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell v-if="isProfileEditable" width="half">
                                <select-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.language.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.language.placeholder')"
                                    :isRequired="false"
                                    :formData="{ selectedLanguage }"
                                    valuePath="selectedLanguage"
                                    :options="languageOptions"
                                    @change="handleLanguageChange($event)"
                                ></select-field>
                            </form-cell>
                            <form-cell v-if="isProfileEditable && isOtherLanguageSelected" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.other_language.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.other_language.placeholder')"
                                    :isRequired="false"
                                    :formData="{ customLanguage }"
                                    valuePath="customLanguage"
                                    @change="handleCustomLanguageChange($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.ssn.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.ssn.placeholder')"
                                    :isDisabled="!isProfileEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="ssn"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                        </form-row>
                    </div>
                </div>
                <div class="Cards">
                    <div class="main-data main-card">
                        <div>
                            <common-icon name="call" size="medium"></common-icon>
                            <span class="card-title">{{ $t('modals.patient_profile.profile.contact_info.card_head') }}</span>
                        </div>
                        <div class="edit-export">
                            <input
                                v-if="isExportProfileClicked"
                                v-model="selectedExportFields.contact"
                                type="checkbox"
                                class="export-checkbox"
                            />
                        </div>
                    </div>
                    <div>
                        <form-row>
                            <form-cell width="half">
                                <phone-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.primary_phone.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.primary_phone.placeholder')"
                                    :isDisabled="!isContactEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="mobilePhone"
                                    type="number"
                                    @change="change($event)"
                                ></phone-field>
                            </form-cell>
                            <form-cell v-if="!isContactEditable" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.contact_info.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.contact_info.placeholder')"
                                    :isDisabled="true"
                                    :formData="data"
                                    valuePath="preferredContactMethod"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell v-if="isContactEditable" width="half">
                                <select-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.contact_info.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.contact_info.placeholder')"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="preferredContactMethod"
                                    :options="preferredContactMethodOptions"
                                    @change="change($event)"
                                ></select-field>
                            </form-cell>
                        </form-row>

                        <form-row>
                            <form-cell width="half">
                                <phone-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.alternate_phone.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.alternate_phone.placeholder')"
                                    :isDisabled="!isContactEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="homePhone"
                                    type="number"
                                    @change="change($event)"
                                ></phone-field>
                            </form-cell>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.email.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.email.placeholder')"
                                    :isDisabled="!isContactEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="email"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                        </form-row>
                    </div>
                </div>
                <section class="Cards">
                    <div class="main-data main-card">
                        <div>
                            <common-icon name="location" size="medium"></common-icon>
                            <span class="card-title">{{ $t('modals.patient_profile.profile.address.card_head') }}</span>
                        </div>
                        <div class="edit-export">
                            <input
                                v-if="isExportProfileClicked"
                                v-model="selectedExportFields.address"
                                type="checkbox"
                                class="export-checkbox"
                            />
                        </div>
                    </div>

                    <div>
                        <form-row>
                            <form-cell width="half">
                                <suggest-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.address.street.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.address.street.placeholder')"
                                    :suggestionsCall="addressSuggestionCall"
                                    :isDisabled="!isAddressEditable"
                                    :isSuggested="false"
                                    :formData="data"
                                    valuePath="address"
                                    @change="change($event)"
                                    @select="changeLocationAddress($event)"
                                ></suggest-field>
                            </form-cell>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.addpatient.fields.floor_number.label')"
                                    :placeholder="$t('forms.addpatient.fields.floor_number.placeholder')"
                                    :isDisabled="!isAddressEditable"
                                    :isSuggested="isAddressSuggested"
                                    :formData="data"
                                    errorPath="floorNumber"
                                    valuePath="floorNumber"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.addpatient.fields.apartment_number.label')"
                                    :placeholder="$t('forms.addpatient.fields.apartment_number.placeholder')"
                                    :isDisabled="!isAddressEditable"
                                    :isSuggested="isAddressSuggested"
                                    :formData="data"
                                    errorPath="apartmentNumber"
                                    valuePath="apartmentNumber"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                        </form-row>
                        <form-row>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.addpatient.fields.building_number.label')"
                                    :placeholder="$t('forms.addpatient.fields.building_number.placeholder')"
                                    :isDisabled="!isAddressEditable"
                                    :isSuggested="isAddressSuggested"
                                    :formData="data"
                                    errorPath="buildingNumber"
                                    valuePath="buildingNumber"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.address.city.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.address.city.placeholder')"
                                    :isDisabled="!isAddressEditable"
                                    :isRequired="false"
                                    :isSuggested="isAddressSuggested"
                                    :formData="data"
                                    valuePath="city"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell v-if="!isAddressEditable" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.address.state.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.address.state.placeholder')"
                                    :isDisabled="true"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="state"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell v-if="isAddressEditable" width="half">
                                <select-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.address.state.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.address.state.placeholder')"
                                    :options="states"
                                    :isDisabled="!isAddressEditable"
                                    :isRequired="false"
                                    :isSuggested="isAddressSuggested"
                                    :formData="data"
                                    valuePath="state"
                                    @change="change($event)"
                                ></select-field>
                            </form-cell>
                        </form-row>
                        <form-row>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.address.zip.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.address.zip.placeholder')"
                                    :isDisabled="!isAddressEditable"
                                    :isRequired="false"
                                    :isSuggested="isAddressSuggested"
                                    :formData="data"
                                    valuePath="zip"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                        </form-row>
                    </div>
                </section>

                <section class="Cards">
                    <div class="main-data main-card">
                        <div>
                            <common-icon name="insure" size="medium"></common-icon>
                            <span class="card-title">Insurance Information</span>
                        </div>
                        <div class="edit-export">
                            <input
                                v-if="isExportProfileClicked"
                                v-model="selectedExportFields.insurance"
                                type="checkbox"
                                class="export-checkbox"
                            />
                        </div>
                    </div>

                    <div>
                        <form-row>
                            <form-cell v-if="!isInsuranceEditable" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.addpatient.fields.insurance_plans.placeholder_patient')"
                                    :placeholder="$t('forms.addpatient.fields.insurance_plans.placeholder_patient')"
                                    :isDisabled="true"
                                    :formData="{ insurancePlanName }"
                                    valuePath="insurancePlanName"
                                ></text-field>
                            </form-cell>
                            <form-cell v-if="isInsuranceEditable" width="half">
                                <label class="form-field__label">
                                    {{ $t('forms.addpatient.fields.insurance_plans.placeholder_patient') }}
                                </label>
                                <select-input
                                    :placeholder="$t('forms.addpatient.fields.insurance_plans.start_typing')"
                                    :options="insurancePlans"
                                    :groupOptions="true"
                                    :expandOptionsRight="true"
                                    :isSearchable="true"
                                    :value="data.primaryInsuranceTypeId"
                                    icon="insurance"
                                    @change="changeInsurancePlan($event)"
                                ></select-input>
                            </form-cell>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.addpatient.fields.insurance.label')"
                                    :placeholder="$t('forms.addpatient.fields.insurance.placeholder')"
                                    :isDisabled="!isInsuranceEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="insuranceGroupNumber"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                        </form-row>
                        <form-row>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.addpatient.fields.insurance_id.label')"
                                    :placeholder="$t('forms.addpatient.fields.insurance_id.placeholder')"
                                    :isDisabled="!isInsuranceEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="insuranceNumber"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                        </form-row>
                    </div>
                </section>

                <section class="Cards">
                    <div class="main-data main-card">
                        <div>
                            <common-icon name="emergancy" size="medium"></common-icon>
                            <span class="card-title">{{ $t('modals.patient_profile.profile.emergency.card_head') }}</span>
                        </div>
                        <div class="edit-export">
                            <input
                                v-if="isExportProfileClicked"
                                v-model="selectedExportFields.emergency"
                                type="checkbox"
                                class="export-checkbox"
                            />
                        </div>
                    </div>

                    <div>
                        <div v-if="isEmergencyEditable" class="contact-card">
                            <form-row>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.first_name.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.first_name.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.firstName"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.last_name.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.last_name.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.lastName"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                            </form-row>
                            <form-row>
                                <form-cell width="half">
                                    <phone-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.phone.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.phone.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :isRequired="false"
                                        :formData="data"
                                        valuePath="emergencyContact.phone"
                                        type="number"
                                        @change="change($event)"
                                    ></phone-field>
                                </form-cell>

                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.email.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.email.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.email"
                                        type="email"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                            </form-row>
                            <form-row>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.relationship.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.relationship.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.relationship"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                            </form-row>
                        </div>
                        <div v-if="hasEmergencyContact(data) && !isEmergencyEditable" class="contact-card">
                            <div class="main">
                                <p class="name">{{ data?.emergencyContact?.firstName }} {{ data?.emergencyContact?.lastName }}</p>
                                <div class="">
                                    <span class="tag">{{ data?.emergencyContact?.relationship }}</span>
                                    <span class="tag primary">Primary</span>
                                </div>
                            </div>
                            <div class="card_grid">
                                <p class="port">
                                    <common-icon name="call" size="small"></common-icon>
                                    {{ data?.emergencyContact?.phone }}
                                </p>
                                <p class="port">
                                    <common-icon name="sms" size="small"></common-icon>
                                    {{ data?.emergencyContact?.email }}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="Cards">
                    <div class="main-data main-card">
                        <div>
                            <common-icon name="link" size="medium"></common-icon>
                            <span class="card-title">{{ $t('modals.patient_profile.profile.pharmacy.card_head') }}</span>
                        </div>
                        <div class="edit-export">
                            <input
                                v-if="isExportProfileClicked"
                                v-model="selectedExportFields.pharmacy"
                                type="checkbox"
                                class="export-checkbox"
                            />
                        </div>
                    </div>
                    <div class="contact-card">
                        <div v-if="isPharmacyEditable">
                            <form-row>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.pharmacy.name.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.pharmacy.name.placeholder')"
                                        :isDisabled="!isPharmacyEditable"
                                        :formData="data"
                                        valuePath="preferredFarmacy.name"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                                <form-cell width="half">
                                    <suggest-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.pharmacy.address.label')"
                                        :placeholder="$t('forms.patient_profile.fields.pharmacy.address.placeholder')"
                                        :suggestionsCall="addressSuggestionCall"
                                        :isRequired="true"
                                        :isDisabled="!isPharmacyEditable"
                                        :isSuggested="isPharmacySuggested"
                                        :formData="data"
                                        valuePath="preferredFarmacy.address"
                                        @change="change($event)"
                                        @select="changePharmacyAddress($event)"
                                    ></suggest-field>
                                </form-cell>
                            </form-row>
                            <form-row>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.profile.address.city.label')"
                                        :placeholder="$t('forms.patient_profile.fields.profile.address.city.placeholder')"
                                        :isDisabled="!isPharmacyEditable"
                                        :isRequired="false"
                                        :isSuggested="isPharmacySuggested"
                                        :formData="data"
                                        valuePath="preferredFarmacy.city"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                                <form-cell width="half">
                                    <select-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.profile.address.state.label')"
                                        :placeholder="$t('forms.patient_profile.fields.profile.address.state.placeholder')"
                                        :options="states"
                                        :isDisabled="!isPharmacyEditable"
                                        :isRequired="false"
                                        :isSuggested="isPharmacySuggested"
                                        :formData="data"
                                        valuePath="preferredFarmacy.state"
                                        @change="change($event)"
                                    ></select-field>
                                </form-cell>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.profile.address.zip.label')"
                                        :placeholder="$t('forms.patient_profile.fields.profile.address.zip.placeholder')"
                                        :isDisabled="!isPharmacyEditable"
                                        :isRequired="false"
                                        :isSuggested="isPharmacySuggested"
                                        :formData="data"
                                        valuePath="preferredFarmacy.zip"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                            </form-row>
                            <form-row>
                                <form-cell width="half">
                                    <phone-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.pharmacy.phone.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.pharmacy.phone.placeholder')"
                                        :isDisabled="!isPharmacyEditable"
                                        :isRequired="false"
                                        :formData="data"
                                        valuePath="preferredFarmacy.phone"
                                        type="number"
                                        @change="change($event)"
                                    ></phone-field>
                                </form-cell>

                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.pharmacy.fax.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.pharmacy.fax.placeholder')"
                                        :isDisabled="!isPharmacyEditable"
                                        :formData="data"
                                        valuePath="preferredFarmacy.fax"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.email.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.email.placeholder')"
                                        :isDisabled="!isPharmacyEditable"
                                        :formData="data"
                                        valuePath="preferredFarmacy.email"
                                        type="email"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                            </form-row>
                        </div>
                        <div v-if="hasPreferredPharmacy(data) && !isPharmacyEditable">
                            <div class="main">
                                <p class="name">{{ data?.preferredFarmacy?.name }}</p>
                                <span class="tag green">
                                    <common-icon name="star" size="tiny"></common-icon>
                                    {{ $t('modals.patient_profile.profile.pharmacy.tag') }}
                                </span>
                            </div>

                            <p class="port">
                                <common-icon name="location" size="small"></common-icon>
                                {{ data?.preferredFarmacy?.address }}, {{ data?.preferredFarmacy?.city }},
                                {{ data?.preferredFarmacy?.state }}, {{ data?.preferredFarmacy?.zip }}
                            </p>

                            <div class="card_grid">
                                <p class="port">
                                    <common-icon name="call" size="small"></common-icon>
                                    {{ data?.preferredFarmacy?.phone }}
                                </p>
                                <p class="port">
                                    <common-icon name="file" size="small"></common-icon>
                                    {{ data?.preferredFarmacy?.fax }}
                                </p>
                            </div>

                            <p class="port">
                                <common-icon name="sms" size="small"></common-icon>
                                {{ data?.preferredFarmacy?.email }}
                            </p>
                        </div>
                    </div>
                </section>

                <section v-if="$route.params.id" class="Cards">
                    <div class="main-data">
                        <div class="title-group">
                            <common-icon name="building" size="medium"></common-icon>
                            <h3 class="card-title">{{ $t('modals.patient_profile.profile.providers.card_head') }}</h3>
                        </div>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.providers"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                    <div v-for="(connection, index) in connections" :key="index" class="contact-card">
                        <p class="user-name">{{ connectionName(connection) }}</p>
                        <div class="main">
                            <p class="label">
                                <span v-if="connection?.user">
                                    {{ connection?.user?.specialities[0]?.speciality.name }}
                                </span>
                            </p>
                            <div class="">
                                <span class="tag primary">{{ $t('modals.patient_profile.profile.providers.primary') }}</span>
                                <span class="tag green">
                                    <common-icon name="check" size="tiny"></common-icon>
                                    {{ $t('modals.patient_profile.profile.providers.in_network') }}
                                </span>
                            </div>
                        </div>
                        <p class="port">{{ connection.practice.name }}</p>
                        <div class="card_grid">
                            <p class="port">
                                <common-icon name="call" size="small"></common-icon>
                                {{ connectionPhone(connection) }}
                            </p>
                            <p class="port">
                                <common-icon name="sms" size="small"></common-icon>
                                {{ connectionEmail(connection) }}
                            </p>
                        </div>
                        <p class="port">
                            <common-icon name="location" size="small"></common-icon>
                            {{ connectionAddress(connection) }}
                        </p>
                    </div>
                </section>

                <div v-if="isExportProfileClicked" class="export-desc">
                    <p>{{ $t('pages.patient.details.text.export_txt') }}</p>
                    <common-buttons>
                        <common-button
                            :isSubmittable="false"
                            :label="$t('pages.patient.details.buttons.secondary')"
                            type="secondary"
                            @click="handleCancelExport"
                        ></common-button>
                        <common-button
                            :isDisabled="!hasSelectedFields"
                            :label="$t('pages.patient.details.buttons.export')"
                            type="primary"
                            @click="openExportModal"
                        ></common-button>
                    </common-buttons>
                </div>
                <div v-if="showEditActionButtons" class="export-desc">
                    <p v-if="$route.params.id">{{ $t('pages.patient.details.text.edit_txt') }}</p>
                    <common-buttons>
                        <common-button
                            v-if="$route.params.id"
                            :isSubmittable="false"
                            :label="$t('pages.patient.details.buttons.secondary')"
                            type="secondary"
                            @click="handleCancel"
                        ></common-button>
                        <common-button
                            :isProcessing="isSending"
                            :label="$t('pages.patient.details.buttons.primary')"
                            type="primary"
                            @click="handleFormSubmission"
                        ></common-button>
                    </common-buttons>
                </div>
                <div v-if="$route.params.id" class="main-data">
                    <button class="btn" type="button" @click="exportBtnClick">
                        <common-icon name="file" size="small"></common-icon>
                        {{ $t('pages.patient.details.buttons.export_profile') }}
                    </button>
                    <button class="btn" type="button" @click="handleEditProfileClick">
                        <common-icon name="setting" size="small"></common-icon>
                        {{ $t('pages.patient.details.buttons.edit_profile') }}
                    </button>
                </div>
            </form-wrapper>
        </div>
        <common-modal v-if="isExportModalOpen" :isOpen="isExportModalOpen" width="large" height="full" @close="closeExportModal">
            <download-profile
                :patientDetails="patientDetails"
                :exportData="buildExportData()"
                @download-pdf="closeExportModalAndClear"
            ></download-profile>
        </common-modal>
    </div>
</template>
<script>
    import Vue from 'vue'
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PatientAPI from 'api/PatientAPI'
    import isEqual from 'lodash.isequal'
    import FormDisableableMixin from 'mixins/FormDisableableMixin'
    import DownloadProfile from '../../page-elements/DownloadProfile.vue'
    import dayjs from 'dayjs'
    import Store from '~/store'
    import StatesAPI from 'api/StatesAPI'
    import cloneDeep from 'lodash.clonedeep'

    function setNestedValue(obj, path, value) {
        if (!obj || !path) return
        if (path.indexOf('.') === -1) {
            Vue.set(obj, path, value)
            return
        }
        const parts = path.split('.')
        let current = obj
        for (let i = 0; i < parts.length - 1; i++) {
            const part = parts[i]
            if (!current[part] || typeof current[part] !== 'object') {
                Vue.set(current, part, {})
            }
            current = current[part]
        }
        Vue.set(current, parts[parts.length - 1], value)
    }

    export default {
        mixins: [FormMixin, HandleRequestMixin, FormDisableableMixin],

        components: { DownloadProfile },

        props: {
            patientDetails: { type: Object, required: true },
        },

        data() {
            return {
                showEditActionButtons: false,
                isProfileEditable: false,
                isContactEditable: false,
                isAddressEditable: false,
                isInsuranceEditable: false,
                isEmergencyEditable: false,
                isPharmacyEditable: false,
                isAddressSuggested: false,
                isPharmacySuggested: false,
                maxNumberOfItems: null,
                changedFields: {},
                connections: [],
                insurancePlans: [],
                states: [],
                isExportProfileClicked: false,
                isExportModalOpen: false,
                selectedLanguage: '',
                customLanguage: '',
                genderOptions: [
                    { label: 'Male', value: 'Male' },
                    { label: 'Female', value: 'Female' },
                ],
                maritalStatusOptions: [
                    { label: 'Married', value: 'Married' },
                    { label: 'Single', value: 'Single' },
                    { label: 'Divorced', value: 'Divorced' },
                    { label: 'Widowed', value: 'Widowed' },
                ],
                languageOptions: [
                    { label: 'English', value: 'English' },
                    { label: 'Spanish', value: 'Spanish' },
                    { label: 'French', value: 'French' },
                    { label: 'Russian', value: 'Russian' },
                    { label: 'Other', value: 'Other' },
                ],
                preferredContactMethodOptions: [
                    { label: 'Phone', value: 'Phone' },
                    { label: 'Email', value: 'Email' },
                ],
                selectedExportFields: {
                    profile: false,
                    contact: false,
                    address: false,
                    insurance: false,
                    emergency: false,
                    pharmacy: false,
                    providers: false,
                    preferences: false,
                    healthcare: false,
                },
            }
        },

        computed: {
            insurancePlanName() {
                const id = this.data.primaryInsuranceTypeId
                if (!id) return ''
                const findInList = (list) => {
                    for (const item of list) {
                        if (item.value === id) return item.label
                        if (item.options) {
                            const found = item.options.find((opt) => opt.value === id)
                            if (found) return found.label
                        }
                    }
                    return ''
                }
                return findInList(this.insurancePlans) || ''
            },
            isOtherLanguageSelected() {
                return this.selectedLanguage === 'Other'
            },
            maxSelectableDate() {
                return dayjs().format('YYYY-MM-DD')
            },
            fullName() {
                return `${this.data.firstName || ''} ${this.data.lastName || ''}`.trim()
            },
            hasSelectedFields() {
                return Object.values(this.selectedExportFields).some(Boolean)
            },
            addressSuggestionCall() {
                //eslint-disable-next-line no-undef
                const autocompleteService = new google.maps.places.AutocompleteService()
                return (query) => {
                    const request = {
                        input: query,
                        componentRestrictions: { country: 'US' },
                    }
                    return autocompleteService.getPlacePredictions(request).then((results) => {
                        return results?.predictions?.map((item) => {
                            return {
                                label: item.description,
                                value: item.place_id,
                            }
                        })
                    })
                }
            },
        },

        methods: {
            exportBtnClick() {
                this.isExportProfileClicked = true
                this.showEditActionButtons = false
            },
            handleEditProfileClick() {
                this.isExportProfileClicked = false
                this.showEditActionButtons = true
                this.isProfileEditable = true
                this.isContactEditable = true
                this.isAddressEditable = true
                this.isInsuranceEditable = true
                this.isEmergencyEditable = true
                this.isPharmacyEditable = true
                this.initLanguage(this.data.preferredLanguage)
            },
            handleCancelExport() {
                this.isExportProfileClicked = false
                this.resetSelectedExportFields()
            },
            openExportModal() {
                this.isExportModalOpen = true
            },
            closeExportModal() {
                this.isExportModalOpen = false
            },
            closeExportModalAndClear() {
                this.handleCancelExport()
                this.closeExportModal()
            },
            resetSelectedExportFields() {
                Object.keys(this.selectedExportFields).forEach((key) => {
                    this.selectedExportFields[key] = false
                })
            },
            buildExportData() {
                const exportData = {}

                if (this.selectedExportFields.profile) {
                    exportData.Profile = {
                        Name: `${this.data.firstName} ${this.data.lastName}`,
                        DOB: this.data.dob,
                        Gender: this.data.gender,
                        MaritalStatus: this.data.maritalStatus,
                        Language: this.data.preferredLanguage,
                        SSN: this.data.ssn,
                    }
                }

                if (this.selectedExportFields.contact) {
                    exportData.Contact = {
                        Mobile: this.data.mobilePhone,
                        ContactMethod: this.data.preferredContactMethod,
                        Home: this.data.homePhone,
                        Email: this.data.email,
                    }
                }

                if (this.selectedExportFields.address) {
                    exportData.Address = {
                        Address: this.data.address,
                        Floor: this.data.floorNumber,
                        Apartment: this.data.apartmentNumber,
                        Building: this.data.buildingNumber,
                        City: this.data.city,
                        State: this.data.state,
                        Zip: this.data.zip,
                    }
                }

                if (this.selectedExportFields.insurance) {
                    exportData.InsuranceInformation = {
                        Plan: this.insurancePlanName || 'N/A',
                        GroupNumber: this.data.insuranceGroupNumber || 'N/A',
                        MemberId: this.data.insuranceNumber || 'N/A',
                    }
                }

                if (this.selectedExportFields.emergency) {
                    const ec = this.data.emergencyContact || {}
                    exportData.EmergencyContact = {
                        Name: `${ec.firstName || ''} ${ec.lastName || ''}`.trim() || 'N/A',
                        Phone: ec.phone || 'N/A',
                        Email: ec.email || 'N/A',
                        Relationship: ec.relationship || 'N/A',
                    }
                }

                if (this.selectedExportFields.pharmacy) {
                    const pf = this.data.preferredFarmacy || {}
                    const { address, city, state, zip } = pf
                    exportData.PreferredPharmacy = {
                        Name: pf.name || 'N/A',
                        Address: [address, city, state, zip].some((v) => v && v.toString().trim())
                            ? [address, city, state, zip].filter(Boolean).join(', ')
                            : 'N/A',
                        Phone: pf.phone || 'N/A',
                        Fax: pf.fax || 'N/A',
                        Email: pf.email || 'N/A',
                    }
                }
                if (this.selectedExportFields.providers) {
                    exportData.Providers = this.connections.map((connection) => ({
                        Name: this.connectionName(connection),
                        Speciality: connection?.user?.specialities?.[0]?.speciality?.name || '',
                        Practice: connection?.practice?.name || '',
                        Phone: this.connectionPhone(connection),
                        Email: this.connectionEmail(connection),
                        Address: this.connectionAddress(connection),
                    }))
                }
                return exportData
            },
            change({ path, value }) {
                this.changedFields[path] = value
                setNestedValue(this.data, path, value)
            },
            changeInsurancePlan(event) {
                const value = event?.value !== undefined ? event.value : event
                this.changedFields['primaryInsuranceTypeId'] = value
                setNestedValue(this.data, 'primaryInsuranceTypeId', value)
            },
            initLanguage(preferredLanguage) {
                const standardLanguages = ['English', 'Spanish', 'French', 'Russian']
                const lang = preferredLanguage ? preferredLanguage.toString().trim() : ''
                const matched = standardLanguages.find((item) => item.toLowerCase() === lang.toLowerCase())
                if (matched) {
                    this.selectedLanguage = matched
                    this.customLanguage = ''
                    return matched
                } else if (lang.length > 0) {
                    this.selectedLanguage = 'Other'
                    this.customLanguage = lang
                    return lang
                } else {
                    this.selectedLanguage = ''
                    this.customLanguage = ''
                    return ''
                }
            },
            handleLanguageChange(event) {
                const value = event?.value !== undefined ? event.value : event
                this.selectedLanguage = value
                if (value === 'Other') {
                    const langVal = this.customLanguage || ''
                    this.$set(this.data, 'preferredLanguage', langVal)
                    this.changedFields['preferredLanguage'] = langVal
                } else {
                    this.customLanguage = ''
                    this.$set(this.data, 'preferredLanguage', value)
                    this.changedFields['preferredLanguage'] = value
                }
            },
            handleCustomLanguageChange(event) {
                const value = event?.value !== undefined ? event.value : event
                this.customLanguage = value
                this.$set(this.data, 'preferredLanguage', value)
                this.changedFields['preferredLanguage'] = value
            },
            handleCancel() {
                this.resetEditStates()
                this.changedFields = {}
                if (this.patientDetails && Object.keys(this.patientDetails).length) {
                    const genderVal = this.patientDetails?.mcard?.gender
                        ? this.patientDetails?.mcard?.gender.charAt(0).toUpperCase() +
                          this.patientDetails?.mcard?.gender.slice(1).toLowerCase()
                        : ''
                    const maritalStatusVal = this.patientDetails?.mcard?.maritalStatus
                        ? this.patientDetails?.mcard?.maritalStatus.charAt(0).toUpperCase() +
                          this.patientDetails?.mcard?.maritalStatus.slice(1).toLowerCase()
                        : ''
                    const preferredLanguageVal = this.initLanguage(this.patientDetails?.mcard?.preferredLanguage)

                    this.$set(this.data, 'gender', genderVal)
                    this.$set(this.data, 'maritalStatus', maritalStatusVal)
                    this.$set(this.data, 'preferredLanguage', preferredLanguageVal)
                    this.$set(this.data, 'primaryInsuranceTypeId', this.patientDetails?.mcard?.primaryInsuranceTypeId || null)
                    this.$set(this.data, 'insuranceGroupNumber', this.patientDetails?.mcard?.groupNumber || '')
                    this.$set(this.data, 'insuranceNumber', this.patientDetails?.mcard?.memberId || '')
                }
            },
            resetEditStates() {
                this.showEditActionButtons = false
                this.isProfileEditable = false
                this.isContactEditable = false
                this.isAddressEditable = false
                this.isInsuranceEditable = false
                this.isEmergencyEditable = false
                this.isPharmacyEditable = false
                this.isAddressSuggested = false
                this.isPharmacySuggested = false
            },
            changeLocationAddress(payload) {
                if (!payload?.value) {
                    return
                }
                //eslint-disable-next-line no-undef
                const placesService = new google.maps.places.PlacesService(document.createElement('div'))
                const request = {
                    placeId: payload.value,
                    fields: ['address_components'],
                }

                placesService.getDetails(request, (place, status) => {
                    //eslint-disable-next-line no-undef
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        const addressComponents = {}
                        place.address_components.forEach((component) => {
                            component.types.forEach((type) => {
                                switch (type) {
                                    case 'street_number':
                                        addressComponents.streetNumber = component.long_name
                                        break
                                    case 'route':
                                        addressComponents.address = component.long_name
                                        break
                                    case 'locality':
                                        addressComponents.city = component.long_name
                                        break
                                    case 'administrative_area_level_1':
                                        addressComponents.state = component.short_name
                                        break
                                    case 'postal_code':
                                        addressComponents.zipCode = component.long_name
                                        break
                                }
                            })
                        })

                        const fullAddr = `${addressComponents.streetNumber || ''} ${addressComponents.address || ''}`.trim()
                        this.data.city = addressComponents.city || ''
                        this.data.state = addressComponents.state || ''
                        this.data.zip = addressComponents.zipCode || ''
                        this.data.address = fullAddr
                        this.$set(this, 'data', { ...this.data })
                        this.changedFields['address'] = fullAddr
                        this.changedFields['city'] = addressComponents.city || ''
                        this.changedFields['state'] = addressComponents.state || ''
                        this.changedFields['zip'] = addressComponents.zipCode || ''
                        this.isAddressSuggested = true
                    }
                })
            },
            changePharmacyAddress(payload) {
                if (!payload?.value) {
                    return
                }
                //eslint-disable-next-line no-undef
                const placesService = new google.maps.places.PlacesService(document.createElement('div'))
                const request = {
                    placeId: payload.value,
                    fields: ['address_components'],
                }
                placesService.getDetails(request, (place, status) => {
                    //eslint-disable-next-line no-undef
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        const addressComponents = {}
                        place.address_components.forEach((component) => {
                            component.types.forEach((type) => {
                                switch (type) {
                                    case 'street_number':
                                        addressComponents.streetNumber = component.long_name
                                        break
                                    case 'route':
                                        addressComponents.address = component.long_name
                                        break
                                    case 'locality':
                                        addressComponents.city = component.long_name
                                        break
                                    case 'administrative_area_level_1':
                                        addressComponents.state = component.short_name
                                        break
                                    case 'postal_code':
                                        addressComponents.zipCode = component.long_name
                                        break
                                }
                            })
                        })
                        const fullAddr = `${addressComponents.streetNumber || ''} ${addressComponents.address || ''}`.trim()
                        const pf = cloneDeep(this.data.preferredFarmacy || {})
                        pf.city = addressComponents.city || ''
                        pf.state = addressComponents.state || ''
                        pf.zip = addressComponents.zipCode || ''
                        pf.address = fullAddr
                        this.$set(this.data, 'preferredFarmacy', pf)

                        this.changedFields['preferredFarmacy.address'] = fullAddr
                        this.changedFields['preferredFarmacy.city'] = addressComponents.city || ''
                        this.changedFields['preferredFarmacy.state'] = addressComponents.state || ''
                        this.changedFields['preferredFarmacy.zip'] = addressComponents.zipCode || ''
                        this.isPharmacySuggested = true
                    }
                })
            },
            handleFormSubmission() {
                this.isSending = true
                this.emitEvent({ name: 'is-sending', payload: this.isSending })
                const patientId = this.$route.params.id

                if (!patientId) {
                    const ecRaw = {
                        firstName:
                            this.data.emergencyContact?.firstName ||
                            this.changedFields['emergencyContact.firstName'] ||
                            undefined,
                        lastName:
                            this.data.emergencyContact?.lastName || this.changedFields['emergencyContact.lastName'] || undefined,
                        phone: this.data.emergencyContact?.phone || this.changedFields['emergencyContact.phone'] || undefined,
                        email: this.data.emergencyContact?.email || this.changedFields['emergencyContact.email'] || undefined,
                        relationship:
                            this.data.emergencyContact?.relationship ||
                            this.changedFields['emergencyContact.relationship'] ||
                            undefined,
                    }

                    const pfRaw = {
                        name: this.data.preferredFarmacy?.name || this.changedFields['preferredFarmacy.name'] || undefined,
                        address:
                            this.data.preferredFarmacy?.address || this.changedFields['preferredFarmacy.address'] || undefined,
                        city: this.data.preferredFarmacy?.city || this.changedFields['preferredFarmacy.city'] || undefined,
                        state: this.data.preferredFarmacy?.state || this.changedFields['preferredFarmacy.state'] || undefined,
                        zip: this.data.preferredFarmacy?.zip || this.changedFields['preferredFarmacy.zip'] || undefined,
                        phone: this.data.preferredFarmacy?.phone || this.changedFields['preferredFarmacy.phone'] || undefined,
                        email: this.data.preferredFarmacy?.email || this.changedFields['preferredFarmacy.email'] || undefined,
                        fax: this.data.preferredFarmacy?.fax || this.changedFields['preferredFarmacy.fax'] || undefined,
                    }

                    const addrRaw = {
                        address: this.data.address || this.changedFields.address || undefined,
                        city: this.data.city || this.changedFields.city || undefined,
                        state: this.data.state || this.changedFields.state || undefined,
                        zip: this.data.zip || this.changedFields.zip || undefined,
                        floorNumber: this.data.floorNumber || this.changedFields.floorNumber || undefined,
                        apartmentNumber: this.data.apartmentNumber || this.changedFields.apartmentNumber || undefined,
                        buildingNumber: this.data.buildingNumber || this.changedFields.buildingNumber || undefined,
                    }

                    const payload = {
                        firstName: this.data.firstName || this.changedFields.firstName,
                        lastName: this.data.lastName || this.changedFields.lastName,
                        dob: this.data.dob || this.changedFields.dob,
                        last4ssn: this.data.ssn || this.data.last4ssn || this.changedFields.ssn || this.changedFields.last4ssn,
                        phoneNumber:
                            this.data.mobilePhone ||
                            this.data.phoneNumber ||
                            this.changedFields.mobilePhone ||
                            this.changedFields.phoneNumber,
                        email: this.data.email || this.changedFields.email || undefined,
                        gender: this.data.gender
                            ? this.data.gender.toString().trim().toLowerCase()
                            : this.changedFields.gender
                            ? this.changedFields.gender.toString().trim().toLowerCase()
                            : null,
                        maritalStatus: this.data.maritalStatus || this.changedFields.maritalStatus || undefined,
                        preferredLanguage: this.data.preferredLanguage || this.changedFields.preferredLanguage || undefined,
                        preferredContactMethod:
                            this.data.preferredContactMethod || this.changedFields.preferredContactMethod || undefined,
                        primaryInsuranceTypeId:
                            this.data.primaryInsuranceTypeId || this.changedFields.primaryInsuranceTypeId || null,
                        insuranceGroupNumber:
                            this.data.insuranceGroupNumber || this.changedFields.insuranceGroupNumber || undefined,
                        insuranceNumber: this.data.insuranceNumber || this.changedFields.insuranceNumber || undefined,
                        guarantor: {},
                        address: addrRaw,
                        emergencyContact: ecRaw,
                        preferredFarmacy: pfRaw,
                    }

                    this.handleRequest(PatientAPI.add(this.$auth.getActiveMember().id, payload))
                        .then((res) => {
                            const newPatientId = res?.id || res?.patientId || res?.data?.id || res?.data?.patientId
                            if (newPatientId) {
                                this.$router.replace({
                                    name: 'patients.details.patients',
                                    params: { id: newPatientId },
                                })
                            }
                        })
                        .finally(() => {
                            this.isSending = false
                            this.emitEvent({ name: 'is-sending', payload: false })
                        })
                    return
                }

                let payload = {}
                if (this.isProfileEditable) {
                    if (this.changedFields.firstName !== undefined) payload.firstName = this.changedFields.firstName
                    if (this.changedFields.lastName !== undefined) payload.lastName = this.changedFields.lastName
                    if (this.changedFields.dob !== undefined) payload.dob = this.changedFields.dob
                    if (this.changedFields.gender !== undefined)
                        payload.gender = this.changedFields.gender
                            ? this.changedFields.gender.toString().trim().toLowerCase()
                            : null
                    if (this.changedFields.ssn !== undefined) payload.last4ssn = this.changedFields.ssn
                    if (this.changedFields.maritalStatus !== undefined) payload.maritalStatus = this.changedFields.maritalStatus
                    if (this.changedFields.preferredLanguage !== undefined)
                        payload.preferredLanguage = this.changedFields.preferredLanguage
                }

                if (this.isContactEditable) {
                    if (this.changedFields.mobilePhone !== undefined) payload.mobilePhone = this.changedFields.mobilePhone
                    if (this.changedFields.homePhone !== undefined) payload.homePhone = this.changedFields.homePhone
                    if (this.changedFields.email !== undefined) payload.email = this.changedFields.email
                    if (this.changedFields.preferredContactMethod !== undefined)
                        payload.preferredContactMethod = this.changedFields.preferredContactMethod
                }

                if (this.isAddressEditable) {
                    const addressKeys = ['address', 'city', 'state', 'zip', 'floorNumber', 'apartmentNumber', 'buildingNumber']
                    const hasAddressChanged = addressKeys.some((key) => this.changedFields[key] !== undefined)
                    if (hasAddressChanged) {
                        payload.address = {
                            address: this.changedFields.address !== undefined ? this.changedFields.address : this.data.address,
                            city: this.changedFields.city !== undefined ? this.changedFields.city : this.data.city,
                            state: this.changedFields.state !== undefined ? this.changedFields.state : this.data.state,
                            zip: this.changedFields.zip !== undefined ? this.changedFields.zip : this.data.zip,
                            floorNumber:
                                this.changedFields.floorNumber !== undefined
                                    ? this.changedFields.floorNumber
                                    : this.data.floorNumber,
                            apartmentNumber:
                                this.changedFields.apartmentNumber !== undefined
                                    ? this.changedFields.apartmentNumber
                                    : this.data.apartmentNumber,
                            buildingNumber:
                                this.changedFields.buildingNumber !== undefined
                                    ? this.changedFields.buildingNumber
                                    : this.data.buildingNumber,
                        }
                    }
                }

                if (this.isInsuranceEditable) {
                    if (this.changedFields.primaryInsuranceTypeId !== undefined) {
                        payload.primaryInsuranceTypeId = this.changedFields.primaryInsuranceTypeId
                    }
                    if (this.changedFields.insuranceGroupNumber !== undefined) {
                        payload.insuranceGroupNumber = this.changedFields.insuranceGroupNumber
                        payload.groupNumber = this.changedFields.insuranceGroupNumber
                    }
                    if (this.changedFields.insuranceNumber !== undefined) {
                        payload.insuranceNumber = this.changedFields.insuranceNumber
                        payload.memberId = this.changedFields.insuranceNumber
                    }
                }

                if (this.isEmergencyEditable) {
                    const emergencyKeys = [
                        'emergencyContact.firstName',
                        'emergencyContact.lastName',
                        'emergencyContact.phone',
                        'emergencyContact.email',
                        'emergencyContact.relationship',
                    ]
                    const hasEmergencyChanged = emergencyKeys.some((key) => this.changedFields[key] !== undefined)
                    if (hasEmergencyChanged) {
                        const ec = this.data.emergencyContact || {}
                        payload.emergencyContact = {
                            firstName:
                                this.changedFields['emergencyContact.firstName'] !== undefined
                                    ? this.changedFields['emergencyContact.firstName']
                                    : ec.firstName,
                            lastName:
                                this.changedFields['emergencyContact.lastName'] !== undefined
                                    ? this.changedFields['emergencyContact.lastName']
                                    : ec.lastName,
                            phone:
                                this.changedFields['emergencyContact.phone'] !== undefined
                                    ? this.changedFields['emergencyContact.phone']
                                    : ec.phone,
                            email:
                                this.changedFields['emergencyContact.email'] !== undefined
                                    ? this.changedFields['emergencyContact.email']
                                    : ec.email,
                            relationship:
                                this.changedFields['emergencyContact.relationship'] !== undefined
                                    ? this.changedFields['emergencyContact.relationship']
                                    : ec.relationship,
                        }
                    }
                }

                if (this.isPharmacyEditable) {
                    const pharmacyKeys = [
                        'preferredFarmacy.name',
                        'preferredFarmacy.address',
                        'preferredFarmacy.city',
                        'preferredFarmacy.state',
                        'preferredFarmacy.zip',
                        'preferredFarmacy.phone',
                        'preferredFarmacy.fax',
                        'preferredFarmacy.email',
                    ]
                    const hasPharmacyChanged = pharmacyKeys.some((key) => this.changedFields[key] !== undefined)
                    if (hasPharmacyChanged) {
                        const pf = this.data.preferredFarmacy || {}
                        payload.preferredFarmacy = {
                            name:
                                this.changedFields['preferredFarmacy.name'] !== undefined
                                    ? this.changedFields['preferredFarmacy.name']
                                    : pf.name,
                            address:
                                this.changedFields['preferredFarmacy.address'] !== undefined
                                    ? this.changedFields['preferredFarmacy.address']
                                    : pf.address,
                            city:
                                this.changedFields['preferredFarmacy.city'] !== undefined
                                    ? this.changedFields['preferredFarmacy.city']
                                    : pf.city,
                            state:
                                this.changedFields['preferredFarmacy.state'] !== undefined
                                    ? this.changedFields['preferredFarmacy.state']
                                    : pf.state,
                            zip:
                                this.changedFields['preferredFarmacy.zip'] !== undefined
                                    ? this.changedFields['preferredFarmacy.zip']
                                    : pf.zip,
                            phone:
                                this.changedFields['preferredFarmacy.phone'] !== undefined
                                    ? this.changedFields['preferredFarmacy.phone']
                                    : pf.phone,
                            fax:
                                this.changedFields['preferredFarmacy.fax'] !== undefined
                                    ? this.changedFields['preferredFarmacy.fax']
                                    : pf.fax,
                            email:
                                this.changedFields['preferredFarmacy.email'] !== undefined
                                    ? this.changedFields['preferredFarmacy.email']
                                    : pf.email,
                        }
                    }
                }

                if (!Object.keys(payload).length) {
                    this.isSending = false
                    this.emitEvent({ name: 'is-sending', payload: false })
                    this.resetEditStates()
                    return
                }

                this.handleRequest(PatientAPI.updatePatientDetails(patientId, this.$auth.getUser().id, payload))
                    .then(() => {
                        this.resetEditStates()
                    })
                    .finally(() => {
                        this.isSending = false
                        this.emitEvent({ name: 'update-patientDetails' })
                        this.resetEditStates()
                    })
            },
            getPatientConnections() {
                const patientId = this.$route.params.id
                if (!patientId) {
                    this.connections = []
                    return
                }
                PatientAPI.getProviderPatientConnections(patientId, {}, { limit: 3, offset: 0 }).then((res) => {
                    this.connections = res
                })
            },
            connectionName(item) {
                if (item.user) {
                    return `${item.user.designation} ${item.user.firstName} ${item.user.lastName}`
                }
                return item.practice?.name || ''
            },
            connectionPhone(item) {
                if (item.user) {
                    return `${item.user.phone}`
                }
                return item.practice?.phone || ''
            },
            connectionEmail(item) {
                if (item.user) {
                    return `${item.user.email}`
                }
                return item.practice?.email || ''
            },
            connectionAddress(item) {
                return `${item?.practice?.address}, ${item?.practice?.city}, ${item?.practice?.state} ${item?.practice?.zip}`
            },
            hasEmergencyContact(item) {
                const e = item?.emergencyContact
                return !!(e && (e.firstName || e.lastName))
            },
            hasPreferredPharmacy(item) {
                const e = item?.preferredFarmacy
                return !!(e && (e.name || e.address || e.phone))
            },
            setNumberOfItems() {
                if (this.isTablet) {
                    this.maxNumberOfItems = 1
                    return
                }
                if (this.isLaptop) {
                    this.maxNumberOfItems = 2
                    return
                }

                this.maxNumberOfItems = 3
            },
        },

        watch: {
            '$route.params.id': {
                immediate: true,
                handler(newId) {
                    if (!newId) {
                        this.isProfileEditable = true
                        this.isContactEditable = true
                        this.isAddressEditable = true
                        this.isInsuranceEditable = true
                        this.isEmergencyEditable = true
                        this.isPharmacyEditable = true
                        this.showEditActionButtons = true
                        this.data = {}
                        this.connections = []
                    } else {
                        this.resetEditStates()
                        this.getPatientConnections()
                    }
                },
            },
            patientDetails: {
                handler(newVal) {
                    if (!newVal || !Object.keys(newVal).length) return
                    if (
                        this.isProfileEditable ||
                        this.isContactEditable ||
                        this.isAddressEditable ||
                        this.isInsuranceEditable ||
                        this.isEmergencyEditable ||
                        this.isPharmacyEditable
                    ) {
                        return
                    }

                    if (newVal && Object.keys(newVal).length) {
                        const genderVal = newVal?.mcard?.gender
                            ? newVal?.mcard?.gender.charAt(0).toUpperCase() + newVal?.mcard?.gender.slice(1).toLowerCase()
                            : ''
                        const maritalStatusVal = newVal?.mcard?.maritalStatus
                            ? newVal?.mcard?.maritalStatus.charAt(0).toUpperCase() +
                              newVal?.mcard?.maritalStatus.slice(1).toLowerCase()
                            : ''
                        const preferredLanguageVal = this.initLanguage(newVal?.mcard?.preferredLanguage)

                        this.data = {
                            ...this.data,
                            firstName: newVal.firstName || '',
                            lastName: newVal.lastName || '',
                            dob: newVal.dateOfBirth || null,
                            gender: genderVal,
                            maritalStatus: maritalStatusVal,
                            ssn: newVal.ssn || null,
                            preferredLanguage: preferredLanguageVal,
                            mobilePhone: newVal?.mobilePhone || null,
                            homePhone: newVal?.homePhone || null,
                            email: newVal.email || '',
                            address: newVal.address || '',
                            floorNumber: newVal.floorNumber || '',
                            apartmentNumber: newVal.apartmentNumber || '',
                            buildingNumber: newVal.buildingNumber || '',
                            city: newVal.city || '',
                            state: newVal.state || '',
                            zip: newVal.zip || '',
                            preferredContactMethod: newVal?.mcard?.preferredContactMethod || '',
                            primaryInsuranceTypeId: newVal?.mcard?.primaryInsuranceTypeId || null,
                            insuranceGroupNumber: newVal?.mcard?.groupNumber || '',
                            insuranceNumber: newVal?.mcard?.memberId || '',
                            emergencyContact: {
                                firstName: newVal.mcard?.emergencyContact?.firstName || '',
                                lastName: newVal.mcard?.emergencyContact?.lastName || '',
                                phone: newVal.mcard?.emergencyContact?.phone || '',
                                email: newVal.mcard?.emergencyContact?.email || '',
                                relationship: newVal.mcard?.emergencyContact?.relationship || '',
                            },
                            preferredFarmacy: {
                                name: newVal?.mcard?.preferredFarmacy?.name || '',
                                address: newVal?.mcard?.preferredFarmacy?.address || '',
                                city: newVal?.mcard?.preferredFarmacy?.city || '',
                                state: newVal?.mcard?.preferredFarmacy?.state || '',
                                zip: newVal?.mcard?.preferredFarmacy?.zip || '',
                                phone: newVal?.mcard?.preferredFarmacy?.phone || '',
                                fax: newVal?.mcard?.preferredFarmacy?.fax || '',
                                email: newVal?.mcard?.preferredFarmacy?.email || '',
                            },
                        }
                    }
                },
                immediate: true,
                deep: false,
            },
            windowWidth() {
                this.setNumberOfItems()
            },
        },

        mounted() {
            this.insurancePlans = Store.getters['auth/getInsurancePlans'] || []
            StatesAPI.getList().then((res) => {
                this.states = res || []
            })
            this.setNumberOfItems()
            this.$on('local:beforeChange', (path) => {
                if (['address', 'city', 'state', 'zip', 'floorNumber', 'apartmentNumber', 'buildingNumber'].includes(path)) {
                    this.isAddressSuggested = false
                }
                if (
                    [
                        'preferredFarmacy.address',
                        'preferredFarmacy.city',
                        'preferredFarmacy.state',
                        'preferredFarmacy.zip',
                    ].includes(path)
                ) {
                    this.isPharmacySuggested = false
                }
            })
            this.$on('local:afterChange', () => {
                this.emitEvent({ name: 'form-changed', payload: !isEqual(this.initialData, this.data) })
            })
            if (this.$route.params.id) {
                this.getPatientConnections()
            }
        },
    }
</script>

<style scoped>
    .heading {
        margin-bottom: 14px;
        font-size: 16px;
        color: oklch(0.21 0.034 264.665);
        font-weight: 500;
    }
    .Cards {
        padding: 15px;
        border-radius: 12px;
        border: 1px solid #ddd;
        margin-bottom: 24px;
        background-color: #fff;
    }
    i.check {
        color: #0fa34d;
    }
    .badge {
        border: 1px solid #ddd !important;
        background-color: #fff !important;
        padding: 3px 11px;
        border-radius: 6px;
        color: oklch(0.145 0 0);
    }
    .btn {
        border: 1px solid #0000001a;
        border-radius: 6.75px;
        padding: 7px 10.5px;
        cursor: pointer;
        font-size: 13px;
        display: inline-flex;
        align-items: center;
        gap: 12px;
        margin-right: 12px;
        background-color: #fff;
        color: #0a0a0a;
        font-weight: 500;
        font-size: 15px;

        svg {
            margin-right: 12px;
        }
        &:hover {
            background-color: #ddd;
            transition: background-color 0.15s ease;
        }
    }
    .main {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
    }
    .main-data {
        display: flex;
        align-items: center;
        margin: 10px 10px 30px;
    }
    @media screen and (max-width: 600px) {
        .main-data {
            width: 100%;
            justify-content: center; /* center horizontally */
        }
    }
    .port {
        font-size: 12px;
        font-weight: 400;
        color: oklch(0.145 0 0);
        margin-top: 10.5px;
    }
    .card-title {
        font-size: 16px;
        font-weight: 300;
        margin: 6px 6px;
        color: oklch(0.145 0 0);
    }
    .row {
        display: flex;
        flex-wrap: wrap;
        margin: 12px 1px;
    }
    .value {
        margin: 1px 0px;
    }
    .col {
        flex: 1;
        min-width: 200px;
        margin-right: 20px;
    }
    .card_grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }
    .card_grids {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        margin-top: 12px;
        width: 75%;
    }
    .value {
        font-size: 12px;
        color: oklch(0.145 0 0);
    }
    .label {
        color: #4a5565;
        font-size: 12.25px;
        font-weight: 400;
    }

    .name {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 14px;
        color: oklch(0.145 0 0);
    }
    .user-name {
        font-weight: 500;
        font-size: 16px;
        color: oklch(0.145 0 0);
    }
    .contact-card {
        border: 1px solid #0000001a;
        border-radius: 9px;
        padding: 14px;
        margin: 10px;
    }

    .tag {
        display: inline-flex;
        align-items: center;
        border: 1px solid #ddd;
        padding: 1.75px 7px;
        border-radius: 6.75px;
        font-size: 12px;
        margin-right: 5px;
        gap: 10px;
        font-weight: 500;
        color: #0a0a0a;
    }

    .tag.primary {
        background: #dbeafe;
        color: #193cb8;
    }

    .tag.green {
        background: #dcfce7;
        color: #016630;
    }
    @media screen and (max-width: 600px) {
        .col {
            margin-top: 12px;
        }
        .card_grid {
            display: block !important;
        }
        .card_grids {
            grid-template-columns: repeat(2, 1fr);
        }
        .card-grid-title {
            width: 196px;
        }
    }
    .main-card {
        display: flex;
        justify-content: space-between;
    }
    .edit-export {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .title-group {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .export-checkbox {
        margin-left: auto;
    }
    .export-desc {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        gap: 8px;
        margin-bottom: 20px;
    }
    .patient-detail-form-text >>> input[type='radio'] {
        opacity: 0 !important;
    }
    .patient-detail-form-text >>> input:disabled:not([type='radio']) {
        border: 0 !important;
        opacity: 1 !important;
        background-color: transparent !important;
        height: 8px;
        color: oklch(0.21 0.034 264.665);
    }
    .patient-detail-form-text.form-field--is-disabled >>> .form-field__label {
        opacity: 1 !important;
        font-weight: 500 !important;
        padding-left: 14px !important;
        color: oklch(0.446 0.03 256.802);
        margin-bottom: 1px;
    }
    .patient-detail-form-text >>> .form-phone-input__area-code.form-phone-input__area-code--disabled {
        opacity: 1 !important;
        border: 0 !important;
        width: 20px !important;
        padding-left: 15px;
        position: relative;
        top: -11px;
    }
</style>
